import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import Fleet from "./components/Fleet";
import Tours from "./components/Tours";
import LakeBanner from "./components/LakeBanner";
import BookingForm from "./components/BookingForm";
import Footer from "./components/Footer";

function SiteLayout() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Fleet />
        <Tours />
        <LakeBanner />
        <BookingForm />
      </main>
      <Footer />
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SiteLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
